var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertDueDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 0C2.33525 0 2.417 0.035119 2.47728 0.0976311C2.53756 0.160143 2.57143 0.244928 2.57143 0.333333V0.666667H6.42857V0.333333C6.42857 0.244928 6.46244 0.160143 6.52272 0.0976311C6.58299 0.035119 6.66475 0 6.75 0C6.83525 0 6.91701 0.035119 6.97728 0.0976311C7.03756 0.160143 7.07143 0.244928 7.07143 0.333333V0.666667C8.13857 0.666667 9 1.56 9 2.66667V8C9 9.10667 8.13857 10 7.07143 10H1.92857C0.861429 10 0 9.10667 0 8V2.66667C0 1.56 0.861429 0.666667 1.92857 0.666667V0.333333C1.92857 0.244928 1.96244 0.160143 2.02272 0.0976311C2.083 0.035119 2.16475 0 2.25 0ZM8.35714 2.66667V3.33333H0.642857V2.66667C0.642857 1.93333 1.21821 1.33333 1.92857 1.33333V1.66667C1.92857 1.75507 1.96244 1.83986 2.02272 1.90237C2.083 1.96488 2.16475 2 2.25 2C2.33525 2 2.417 1.96488 2.47728 1.90237C2.53756 1.83986 2.57143 1.75507 2.57143 1.66667V1.33333H6.42857V1.66667C6.42857 1.75507 6.46244 1.83986 6.52272 1.90237C6.58299 1.96488 6.66475 2 6.75 2C6.83525 2 6.91701 1.96488 6.97728 1.90237C7.03756 1.83986 7.07143 1.75507 7.07143 1.66667V1.33333C7.77857 1.33333 8.35714 1.93 8.35714 2.66667ZM0.642857 8V4H8.35714V8C8.35714 8.73333 7.78179 9.33333 7.07143 9.33333H1.92857C1.22143 9.33333 0.642857 8.73667 0.642857 8Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDueDateIcon);
export default __webpack_public_path__ + "static/media/alertDueDateIcon.a403dfb859f49eb396f5dbbec482b033.svg";
export { ForwardRef as ReactComponent };